import useAuthKitSignOut from "react-auth-kit/hooks/useSignOut";
import {useGlobalStore} from "@/stores";

export const useSignOut = () => {
    const store = useGlobalStore()
    const signOut = useAuthKitSignOut()
    return () => {
        store.resetStore()
        signOut()
    };
}